import { isAdmin } from '../services/rolesSvc';

export const getProgramIndicatorsPerms = (userCtx) => ({
  canEdit: !!isAdmin(userCtx),
})
